<template>
  <div>
    <div class="addOrEdit">
      <el-form ref="addOrEditForm" :model="submitData" label-position="right" label-width="200px">
        <el-form-item label="业务订单号：" prop="orderCode" :rules="[{ required: true, message: '业务订单号不能为空', trigger: 'blur' }]">
          <el-input v-model="submitData.orderCode" name="orderCode" class="handle-form-input" placeholder="业务订单号不能为空" />
        </el-form-item>
        <el-form-item label="支付单号：" prop="thirdPaymentCode" :rules="[{ required: true, message: '支付单号不能为空', trigger: 'blur' }]">
          <el-input v-model="submitData.thirdPaymentCode" name="thirdPaymentCode" class="handle-form-input" placeholder="支付单号不能为空" />
        </el-form-item>
        <!-- :rules="[{ required: true, message: '该订单所属的推广者ID不能为空', trigger: 'blur' }]" -->
        <el-form-item label="所属推广者：" prop="spreadCode">
          <el-input v-model="submitData.spreadCode" name="spreadCode" class="handle-form-input" placeholder="请输入该订单所属的推广者ID" />
        </el-form-item>
        <el-form-item label="姓名：" prop="teacherName" :rules="[{ required: true, message: '组织管理员的姓名不能为空', trigger: 'blur' }]">
          <el-input v-model="submitData.teacherName" name="teacherName" maxlength="30" class="handle-form-input" placeholder="请输入组织管理员的姓名" />
        </el-form-item>
        <el-form-item label="手机号：" prop="phoneNumber" :rules="[{ required: true, message: '组织管理员的手机号不能为空', trigger: 'blur'}]">
          <el-input v-model="submitData.phoneNumber" :disabled="orderId ? true:false" name="phoneNumber" maxlength="11" class="handle-form-input" placeholder="请输入组织管理员的手机号" />
        </el-form-item>
        <el-form-item label="授权账号数（个）：" prop="authorizationQuantity" :rules="[{ required: true, message: '组织购买的授权账号数不能为空', trigger: 'blur'}]">
          <el-input v-model="submitData.authorizationQuantity" maxlength="4" name="authorizationQuantity" class="handle-form-input" placeholder="请输入组织购买的授权账号数" />
        </el-form-item>
        <el-form-item label="区域：" prop="areaInfo" :rules="[{ required: true, message: '区域不能为空', trigger: 'blur' }]">
          <el-cascader v-model="submitData.areaInfo" :options="areaData" :props="areaProps" class="handle-form-input" clearable placeholder="选择省/市/区县" @change="areaChange" />
        </el-form-item>
        <el-form-item label="组织名称：" prop="organizationName" :rules="[{ required: true, message: '组织名称不能为空', trigger: 'blur' }]">
          <el-input v-model="submitData.organizationName" name="organizationName" class="handle-form-input" placeholder="请输入组织的全称" />
        </el-form-item>
        <el-form-item label="账号类型：" prop="organizationTypeCode" :rules="[{ required: true, message: '组织类型不能为空', trigger: 'blur' }]">
          <el-select v-model="submitData.organizationTypeCode" name="organizationTypeCode" size="medium" placeholder="请选择组织类型">
            <el-option v-for="(item,index) in organList" :key="index" :label="item.name" :value="item.code" />
          </el-select>
        </el-form-item>
        <el-form-item label="授权库存有效期（月）：" prop="authorizationActivationTerm" :rules="[{ required: true, message: '授权库存期限不能为空', trigger: 'blur' }]">
          <el-input v-model="submitData.authorizationActivationTerm" maxlength="4" name="authorizationActivationTerm" class="handle-form-input" placeholder="请输入授权库存期限" />
        </el-form-item>
        <el-form-item label="授权期限（月）：" prop="authorizationTerm" :rules="[{ required: true, message: '授权期限不能为空', trigger: 'blur' }]">
          <el-input v-model="submitData.authorizationTerm" maxlength="4" name="authorizationTerm" class="handle-form-input" placeholder="请输入授权期限" />
        </el-form-item>
        <el-form-item label="实付金额（元）：" prop="afterDiscountAmount" :rules="[{ required: true, message: '组织实付金额不能为空', trigger: 'blur' }]">
          <el-input v-model="submitData.afterDiscountAmount" name="afterDiscountAmount" maxlength="6" class="handle-form-input" placeholder="请输入组织实付金额" />
        </el-form-item>
        <el-form-item label="支付时间：" prop="orderFinishTime" :rules="[{ required: true, message: '支付时间不能为空', trigger: 'blur' }]">
          <el-date-picker v-model="submitData.orderFinishTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" :picker-options="pickerOptions" placeholder="选择日期" />
        </el-form-item>
        <el-form-item label="支付凭证：" :required="true">
          <div v-if="submitData.voucherPictureUrl" class="pictureBox">
            <img class="img-uploader" :src="submitData.voucherPictureUrl" @mouseover="()=>showImgDelCover=true">
            <span v-show="showImgDelCover" class="mark" @mouseout="()=>showImgDelCover=false">
              <i class="el-icon-delete" @click="()=>submitData.voucherPictureUrl=null" />
            </span>
          </div>
          <upload-file
            v-else
            ref="uploadFile"
            :props="{ serveCode: 'order_payment_img', accept: '.png, .jpg, .jpeg', type: ['image/jpeg', 'image/jpg', 'image/png']}"
            @uploadSucess="uploadSucessImg"
            @fileUploading="fileUploadingFn"
          >
            <div class="up_btns">
              <el-button style="margin-right:10px" icon="el-icon-plus">
                上传图片
              </el-button>
            </div>
          </upload-file>
        </el-form-item>
        <el-form-item v-if="statusInfo.orderStatus===-1" label="审核不通过原因：" prop="">
          {{ statusInfo.approvalReason }}
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="$emit('closeDialog')">
          取消
        </el-button>
        <el-button type="primary" size="medium" :loading="ajaxLoading" @click="handleAddOrEditForm">
          {{ ajaxLoading ? "Loading" : statusInfo.orderStatus===-1 ? '重新发起审核' :"确认" }}
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { addOrgOrders, updateOrgOrders, getOrganizationsTypes } from '@/api/yzdPlatformManage/orderManage';
import { ordersDetail } from '@/api/yzdPlatformManage/userManage.js';
export default {
  props: {
    orderId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      value1: '',
      showImgDelCover: false,
      organList: [],
      submitData: {
        orderCode: '', // 业务订单号
        thirdPaymentCode: '', // 支付单号
        spreadCode: '', // 所属推广者
        teacherName: '', // 姓名
        phoneNumber: '', // 手机号
        authorizationQuantity: '', // 授权账号数（个）
        provinceCode: '', // 省份编码
        cityCode: '', // 市编码
        areaCode: '', // 区编码
        organizationName: '', // 组织名称
        organizationTypeCode: '', // 账号类型
        authorizationActivationTerm: '', // 授权库存有效期（月）
        authorizationTerm: '', // 授权期限（月）
        afterDiscountAmount: '', // 实付金额（元）
        voucherPictureUrl: '', // 支付凭证
        areaInfo: [],
        orderFinishTime: ''// 支付时间
      },
      areaProps: {
        value: 'code',
        label: 'name',
        children: 'children',
        checkStrictly: true
      },
      // areaInfo: '',
      ajaxLoading: false,
      fileUploading: false,
      statusInfo: {
        orderStatus: '',
        approvalReason: ''
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      }
    };
  },
  computed: {
    ...mapGetters(['areaData'])
  },
  mounted() {
    this.$store.dispatch('getNodes'); // 获取区域
    this.getTypes();
    if (this.orderId) {
      this.initData();
    }
  },
  methods: {
    getTypes() {
      getOrganizationsTypes().then(res => {
        if (res.code === '0') {
          this.organList = res.data;
        }
      });
    },
    initData() {
      ordersDetail(this.orderId).then(res => {
        const data = res.data;
        this.statusInfo = {
          orderStatus: data.orderStatus,
          approvalReason: data.approvalReason
        };
        // this.areaInfo = ['100010', '100011', '100012'];
        this.submitData = {
          orderCode: data.orderCode, // 业务订单号
          thirdPaymentCode: data.thirdPaymentCode, // 支付单号
          spreadCode: data.spreadCode, // 所属推广者
          teacherName: data.teacherName, // 姓名
          phoneNumber: data.teacherPhoneNumber, // 手机号
          authorizationQuantity: data.authorizationQuantity, // 授权账号数（个）
          provinceCode: data.provinceCode, // 省份编码
          cityCode: data.cityCode, // 市编码
          areaCode: data.areaCode, // 区编码
          organizationName: data.organizationName, // 组织名称
          organizationTypeCode: data.organizationTypeCode, // 账号类型
          authorizationActivationTerm: data.authorizationActivationTerm, // 授权库存有效期（月）
          authorizationTerm: data.authorizationTerm, // 授权期限（月）
          afterDiscountAmount: data.afterDiscountAmount, // 实付金额（元）
          voucherPictureUrl: data.voucherPictureUrl, // 支付凭证
          areaInfo: [data.provinceCode, data.cityCode, data.areaCode],
          orderFinishTime: data.paymentFinishTime
        };
      });
    },
    areaChange(val) {
      if (!val) {
        return;
      }
      this.submitData.provinceCode = val[0] ? val[0] : '';
      this.submitData.cityCode = val[1] ? val[1] : '';
      this.submitData.areaCode = val[2] ? val[2] : '';
      this.submitData.areaInfo = val;
    },
    // 新增/编辑 订单
    handleAddOrEditForm() {
      if (!this.submitData.voucherPictureUrl) {
        this.$message.error('凭证不能为空');
        return;
      }
      this.$refs['addOrEditForm'].validate((valid) => {
        if (valid) {
          if (this.orderId) {
            this.updateOrderManage();
          } else {
            this.addOrderManage();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    addOrderManage() {
      delete this.submitData.areaInfo;
      this.ajaxLoading = true;
      addOrgOrders(this.submitData).then((res) => {
        this.ajaxLoading = false;
        this.$notify.success({ title: 'Success', message: '新增成功', showClose: false, duration: 2000 });
        this.$emit('getTableList');
        this.$emit('closeDialog');
        this.$refs.submitData.resetFields();
      }).catch(() => {
        this.ajaxLoading = false;
      });
    },
    updateOrderManage() {
      delete this.submitData.areaInfo;
      this.ajaxLoading = true;
      updateOrgOrders({ ...this.submitData, orderId: this.orderId }).then((res) => {
        this.ajaxLoading = false;
        this.$notify.success({ title: 'Success', message: '编辑成功', showClose: false, duration: 2000 });
        this.$emit('getTableList');
        this.$emit('closeDialog');
        this.$refs.submitData.resetFields();
      }).catch(() => {
        this.ajaxLoading = false;
      });
    },
    uploadSucessImg(val) {
      this.submitData.voucherPictureUrl = val.absolutePath;
    },
    fileUploadingFn(val) {
      this.fileUploading = val;
    }
  }
};
</script>
<style lang="scss" scoped>
.addOrEdit{
    .dialog-footer {
        text-align: right;
    }
    .pictureBox{
      position: relative;
      display: inline-block;
      line-height: 0;
      font-size: 0;
      margin-right: 10px;
      .mark{
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background: rgba(0,0,0,0.2);
        color: #fff;
        font-size: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        .el-icon-delete{cursor: pointer;}
      }
    }
    .img-uploader{
        width: 400px;
        height: 200px;
    }
}
</style>
